module.exports = __webpack_public_path__ + "static/media/2.11c31f11.jpg";